import { Buffer } from 'buffer';
import forge from 'node-forge';

import generatePublicKey from './generatePublicKey';

const encryptCardForTabapay = (
  cardNumbers: string,
  expDate: string,
  cvv: string,
  tabapayPublicKey: string
): string => {
  const { pki, util } = forge;
  const cardInfo = formatCardInfoToEncrypt(cardNumbers, expDate, cvv);
  try {
    const publicKey = pki.publicKeyFromPem(generatePublicKey(tabapayPublicKey));

    // Tabapay require to encrypt the data with RSA with Transformation of: RSA/ECB/OAEPWithSHA-256AndMGF1Padding
    // node-forge documentation says 'RSA-OAEP' is the same thing as that transformation
    // more info: https://chimebank.atlassian.net/wiki/x/1QBcFQ then search by: Link card
    const toEncrypt = Buffer.from(cardInfo);
    const encryptedText = publicKey.encrypt(toEncrypt.toString(), 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha256.create(),
      },
    });

    // We need to encode to Base64 and then we need to encode again with url-safe
    const encryptedBase64 = util.encode64(encryptedText);
    const encryptedASN1 = urlSafeEncode(encryptedBase64);

    return encryptedASN1;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

function formatCardInfoToEncrypt(
  cardNumbers: string,
  expDate: string,
  cvv: string
): string {
  const numbers = cardNumbers.replace(/\s/g, '');
  const date = formatExpirationDateForEncryption(expDate);

  /**
   TabaPay require the card info format as:
   card numbers | expiration date | cvv
   example : 9481111999999992|209912|231
   */
  return `${numbers}|${date}|${cvv}`;
}

function formatExpirationDateForEncryption(expDate: string) {
  const [month, last2digitYear] = expDate.split('/');

  /**
   * Tabapay require the expiration date format as: 202012 (full year + month)
   */
  return `20${last2digitYear}${month}`;
}

function urlSafeEncode(str: string) {
  return str.replace(/\+/g, '-').replace(/\//g, '_');
}

export default encryptCardForTabapay;
